// @flow
import Home from './views/Home';
import About from './views/About';
import Privacy from './views/Privacy';
import Terms from './views/Terms';

export const routes = [
  {
    title: 'Home',
    path: '/',
    component: Home,
    exact: true,
  },
  {
    title: 'About',
    path: '/about',
    component: About,
  },
  {
    title: 'Terms',
    path: '/terms',
    component: Terms,
  },
  {
    title: 'Privacy',
    path: '/privacy-policy',
    component: Privacy,
  },
];
